import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-end-marker',
	template: '<img class="img-fluid end-marker my-3" src="/assets/images/teamtime-logo.svg" alt="end marker" />',
	styles: ['.end-marker { filter: grayscale(100%); width: 50px; opacity: 0.075; }']
})
export class EndMarkerComponent {
}
